import React from 'react';
import { TRANSFER_STATUS_TAG } from 'utils/constants';
import { ENUM_TRANSFER_STATUS } from 'models/transfer-request.model';

const TransferStatusTag = ({ type }: { type: ENUM_TRANSFER_STATUS }) => {
  const { bgColor, text, textColor } = TRANSFER_STATUS_TAG[type];
  return (
    <div
      style={{
        backgroundColor: bgColor,
        color: textColor
      }}
      className={`flex items-center gap-1 capitalize rounded-[40px] font-medium text-xs leading-[19px] px-3 py-1`}>
      <p
        className='w-[8px] h-[8px] rounded-full'
        style={{
          backgroundColor: textColor
        }}
      />
      {text}
    </div>
  );
};

export default TransferStatusTag;
